export var EParticipantInviteStatus;
(function (EParticipantInviteStatus) {
    EParticipantInviteStatus["INVITED"] = "invited";
    EParticipantInviteStatus["EXPIRED"] = "expired";
    EParticipantInviteStatus["ACCEPTED"] = "accepted";
})(EParticipantInviteStatus || (EParticipantInviteStatus = {}));
